<div class="custom-modal-container">
  <div class="custom-modal-container-content primary">
    <div (click)="onClose()" class="close-button" *ngIf="context && !context.isClose">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-cross"></use>
      </svg>
    </div>

    <span class="modal-icon">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#500"></use>
      </svg>
    </span>

    <div class="content-container">
      <h2 class="modal-title">{{ 'Oops, something went wrong.' | translate }}</h2>
      <p class="modal-subtitle">{{ 'We have been automatically alerted of the issue and are working to fix it as soon as possible.' | translate }}</p>

      <div class="button-container">
        <a class="primary-button" (click)="onClose()">{{ 'Take me out from here' | translate }}</a>
      </div>
    </div>
  </div>
</div>
